import { CHARACTER_ENGINE } from '../constants/simulationConstants';
import { resolveEmotionEngineType } from '../helpers/emotion';
import { isNudgytAgentClient } from '../helpers/utils';
import { useEmotionOverlay } from './useEmotionOverlay';

/**
 * Emotion overlay for 3JS avatars (Nudgyt Agent + Convai Classic).
 * Lipsync runs separately via useAvatarLipsync.
 */
export const useAvatarEmotion = ({ client, scene, enabled = true }) => {
  const isAgent = isNudgytAgentClient(client);

  useEmotionOverlay({
    client,
    scene,
    enabled,
    engineType: resolveEmotionEngineType({
      isAgentClient: isAgent,
      characterEngineType: CHARACTER_ENGINE.NUDGYT_CLASSIC
    }),
    scaleByConfidence: isAgent
  });
};
